export interface PlanningWizardDTO {
  opportunityId: number;
  pepResourceId: number;
  numberOfHours: number;
  distributionHours: SpreadAlgorithm;
  dateStart: string;
  dateEnd: string;
  disciplineId?: number;
  geoId?: string;
  professionalFigureId?: string;
  hoursToPlan?: number;
}

export enum SpreadAlgorithm {
  MaxOnStart,
  RampUp,
  Linear,
  FteHours,
}
